import { Injectable } from '@angular/core';
import { CardPaymentPartialState } from '@common/data-access-card-payment';
import { CheckoutPartialState } from '@common/data-access-checkout';
import { FeatureConfigPartialState } from '@common/data-access-feature-config';
import {
  QuotesPageSelectors,
  QuotesPartialState,
  QuotesSelectors,
} from '@common/data-access-quotes';
import { SelectPaymentPartialState } from '@common/data-access-select-payment';
import { UserProfilePartialState } from '@common/data-access-user-profile';
import { filterNullUndefined } from '@common/util-foundation';
import {
  CheckoutCompletedItem,
  CheckoutConfirmationTaggingData,
  Quote,
} from '@common/util-models';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import * as OrderConfirmationPageSelectors from './order-confirmation-page.selectors';

@Injectable()
export class OrderConfirmationFacade {
  quote$ = this.store.pipe(
    select(QuotesPageSelectors.getQuote),
    filter((quote) => !!quote)
  ) as Observable<Quote>;

  selectedContractType$ = this.store.pipe(
    select(QuotesPageSelectors.getSelectedContractType)
  );

  checkedOutItem$ = this.store.pipe(
    select(OrderConfirmationPageSelectors.getFirstCheckedOutItem),
    filter((checkedOutItem) => checkedOutItem !== undefined)
  ) as Observable<CheckoutCompletedItem>;

  personalDetails$ = this.store.pipe(
    select(OrderConfirmationPageSelectors.getPersonalDetails)
  );

  preferredPaymentDay$ = this.store.pipe(
    select(OrderConfirmationPageSelectors.getPreferredPaymentDay)
  );

  isHeating$ = this.store.pipe(
    select(QuotesSelectors.getCurrentItemIsHeatingAppliance)
  );

  checkoutConfirmationData$ = this.store.pipe(
    select(OrderConfirmationPageSelectors.getCheckoutConfirmation)
  );

  taggingData$ = this.store.pipe(
    select(OrderConfirmationPageSelectors.getPageLandingTaggingData)
  ) as Observable<CheckoutConfirmationTaggingData>;

  checkoutPlanDetails$ = this.store.pipe(
    select(OrderConfirmationPageSelectors.getPlanDetails)
  );

  checkoutMultiPlanDetails$ = this.store.pipe(
    select(OrderConfirmationPageSelectors.getMultiPlanDetails)
  );

  planNumber$ = this.store.pipe(
    select(OrderConfirmationPageSelectors.getFirstCheckedOutItem),
    filterNullUndefined(),
    map((checkedOutItem) => checkedOutItem.confirmation.planNumber)
  );

  constructor(
    private store: Store<
      CheckoutPartialState &
        UserProfilePartialState &
        QuotesPartialState &
        SelectPaymentPartialState &
        CardPaymentPartialState &
        FeatureConfigPartialState
    >
  ) {}
}
